"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const ListActionEditIcon = (props) => {
    if (!props.canRead)
        return null;
    return ((0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: `${props.canUpdate ? 'რედაქტირება' : 'ნახვა'}`, children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: 'btn btn-sm btn-clean btn-icon btn-icon-md', to: props.editLink, children: (0, jsx_runtime_1.jsx)("i", { className: `${props.canUpdate ? 'la la-edit' : 'far fa-eye'}` }) }) }));
};
exports.default = ListActionEditIcon;
